import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { selectIsAuth } from "src/store/authSlice";
import { useSelector } from "src/store/Store";
import SignIn from "src/components/accout/SignIn";

interface LocationState {
  from: {
    pathname: string;
  };
}

function SignInPage() {
  // const location = useLocation();

  // const path = location.state ? (location.state as LocationState).from : "/";

  // const isAuthenticated = useSelector(selectIsAuth);

  return <SignIn />;
}

export default SignInPage;
